module.exports = __webpack_public_path__ + "img/favicon.d3abd41.png";